var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useMsal } from '@azure/msal-react';
import { Box, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { Order_By } from '../../models/GQLGeneratedModels';
import { getShareLinkId } from '../../services/SaveLoadSearchService';
import { ApplicationContext } from '../ApplicationProvider';
import { ConfigitContext } from '../ConfigitProvider';
import { ButtonComponent } from '../shared/ButtonComponent/ButtonComponent';
import { TextBoxComponent } from '../shared/TextBoxComponent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ShareSearch = function () {
    var azureADPCA = useMsal().instance;
    var _a = useContext(ApplicationContext), itemOffset = _a.itemOffset, itemsPerPage = _a.itemsPerPage, filters = _a.filters;
    var _b = useContext(ConfigitContext), layers = _b.layers, variableAssignments = _b.variableAssignments, manufacturerProduct = _b.manufacturerProduct, excludedLayerIds = _b.excludedLayerIds;
    var _c = useState(''), url = _c[0], setUrl = _c[1];
    var _d = useState(false), copied = _d[0], setCopied = _d[1];
    var _e = useState(false), linkCreated = _e[0], setLinkCreated = _e[1];
    var _f = useState(''), createdLinkGuid = _f[0], setCreatedLinkGuid = _f[1];
    useEffect(function () {
        var createShareLink = function () { return __awaiter(void 0, void 0, void 0, function () {
            function sleep(ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); } // Get user Guid
            var _azureADPCA$getActive, userGuid, shareLinkGuid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userGuid = (_azureADPCA$getActive = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive === void 0 ? void 0 : _azureADPCA$getActive.localAccountId;
                        return [4 /*yield*/, getShareLinkId(layers, variableAssignments, excludedLayerIds, manufacturerProduct, itemsPerPage, itemOffset, { AssemblyId: Order_By.Asc, CoverSubassemblyId: Order_By.Asc, DeckSubassemblyId: Order_By.Asc }, userGuid)];
                    case 1:
                        shareLinkGuid = _a.sent();
                        return [4 /*yield*/, sleep(2000)];
                    case 2:
                        _a.sent(); //return shareLinkGuid;
                        setCreatedLinkGuid(shareLinkGuid);
                        setLinkCreated(true);
                        setUrl("".concat(window.location.protocol, "//").concat(window.location.host, "/loadShareLinkSearchCriteria/").concat(shareLinkGuid));
                        return [2 /*return*/];
                }
            });
        }); };
        if (!linkCreated) {
            createShareLink();
        }
    }, []);
    var handleCopy = function () { navigator.clipboard.writeText(url); setCopied(true); };
    return /*#__PURE__*/ _jsxs(Box, { gap: 2, display: "flex", flexDirection: "column", children: [/*#__PURE__*/ _jsx(Typography, { className: 'py-2', fontFamily: 'Inter', fontSize: '16px', lineHeight: '20px', children: "Click below to copy your shareable link." }), /*#__PURE__*/ _jsx(TextBoxComponent, { id: "url", value: url }), !copied && /*#__PURE__*/ _jsx(ButtonComponent, { buttonStyle: "ml-0", buttonType: "primary", buttonText: "Copy Link", click: handleCopy }), copied && /*#__PURE__*/ _jsx(ButtonComponent, { buttonStyle: "ml-0", buttonType: "primary", buttonText: "Link Copied", click: function () { }, iconName: "check" })] });
};
export default ShareSearch;
